import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, CardBody} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaTrash, FaEraser, FaArrowUp, FaArrowDown, FaGripVertical } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import api from "../../services/api";
import { hasPerm, tiposCampos, tiposRepeater } from '../../common/utils';
import Paginacao from '../../common/pagination';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import withReactContent from 'sweetalert2-react-content';
import CamposTraducao from '../Traducoes/CamposTraducao';
import { alteraTraducao } from '../Traducoes/traducoes';
import { useEffect, useState } from "react";

const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};

class CamposPersonalizadosAtendimentos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaRegistro = this.buscaRegistro.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            campo_personalizado_atendimento_id: null,
            page_numb: 1,
            programas_list: [{programa_id: null, programa__nome: '', secao: '', disclaimer: '', gerar_historico: false, exibir_filtro_exames: false}],
            doencas_list: [{doenca_id: null, doenca__nome: ''}],
            repetidor_list: [{ atendimento_campo_id: null, nome: '', slug: '', descricao: '', tipo: '', obrigatorio: '', opcoes: ''}],
            programas_register: [],
            traducoes: {},
            mostrarTraducoes: false,
            nome: '',
            slug: '', 
            descricao: '', 
            ordem: '', 
            tipo: '',
            obrigatorio: '', 
            extencoes_permitidas: '', 
            opcoes: '', 
            mascara: '', 
            loading: false,
            limit_results: 80,
        };
    }

    componentDidMount(){
        this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb)
    }

    consultaCamposPersonalizados(busca, page_numb=1){
        let url=`/atendimentos/campos/?nome=${busca}&page=${page_numb}&order=ordem&order_by=asc&limit=${this.state.limit_results}`
        if(this.state.filtro_programa_id){
            url += `&programa_id=${this.state.filtro_programa_id}`
        }
        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar campos personalizados atendimentos, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    splitMascaraTopLevel = (mascara = '') => {
        const tokens = [];
        let atual = '';
        let bracketDepth = 0;

        for (const ch of (mascara || '')) {
            if (ch === '[') bracketDepth += 1;
            if (ch === ']') bracketDepth = Math.max(0, bracketDepth - 1);

            if (ch === '|' && bracketDepth === 0) {
                tokens.push(atual);
                atual = '';
                continue;
            }

            atual += ch;
        }

        if (atual) tokens.push(atual);
        return tokens;
    };

    normalizeMascara = (mascara = '') => {
        if (!mascara || typeof mascara !== 'string') return '';

        let normalized = mascara
            .trim()
            .replace(/\s*\|\s*/g, '|')
            .replace(/\|{2,}/g, '|')
            .replace(/^\||\|$/g, '');

        normalized = normalized.replace(
            /(show-on(?:-any|-all)?\[[^\]]*?)(?=\|(information-field|policy-accept|position-bottom|divisor|context=(?:new|edit|both)|minLength=\d+|maxLength=\d+|position-(?:after|before)=))/gi,
            '$1]'
        );

        const tokens = this.splitMascaraTopLevel(normalized)
            .map(token => token.trim())
            .filter(Boolean)
            .map((token) => {
                if (/^show-on(?:-any|-all)?\[/i.test(token) && !token.includes(']')) {
                    return `${token}]`;
                }
                return token;
            });

        return tokens.join('|');
    };

    salvarCampo = async (e, tipo_update) => {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            loading: true,
        });

        // Verifica se é uma atualização de campo e não uma atualização de ordem
        if (tipo_update !== "ordem" && this.state.campo_personalizado_atendimento_id) {
            // Cria uma promessa para confirmar a alteração
            const confirmarAlteracao = async () => {
                const MySwal = withReactContent(Swal);
                const result = await MySwal.fire({
                    title: 'Confirmação',
                    html: <p>Deseja realmente alterar este campo personalizado?</p>,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, alterar',
                    cancelButtonText: 'Cancelar',
                    showCloseButton: true,
                });
                
                // Se o usuário confirmar, retorna true, caso contrário, false
                return result.isConfirmed;
            };
            
            // Verifica se o usuário confirmou a alteração
            const confirmado = await confirmarAlteracao();
            if (!confirmado) {
                this.setState({ loading: false });
                return; // Interrompe a execução se o usuário cancelar
            }
        }
        let payload = {};
        //vererifica se é edição ou adição
        const url = (this.state.campo_personalizado_atendimento_id) ? '/atendimentos/campos/'+this.state.campo_personalizado_atendimento_id+'/' : '/atendimentos/campos/'
        const metodo = (this.state.campo_personalizado_atendimento_id) ? 'put' : 'post'
        if(tipo_update == "ordem") {
            payload = {
                tipo_update: tipo_update,
                campos_ordem: this.state.listRegistros.results.map((item, index) => ({
                    campo_personalizado_atendimento_id: item.id,
                    programa_id: this.state.filtro_programa_id,
                    ordem: index + 1
                }))
            };
        } else {
            payload = {
                nome: this.state.nome,
                slug: this.state.slug,
                tipo: this.state.tipo,
                status: true,   
                programas_register: this.state.programas_list.map(programa => ({
                    programa_id: programa.programa_id,
                    programa__nome: programa.programa__nome,
                    secao: programa.secao,
                    disclaimer: programa.disclaimer || '',
                    gerar_historico: programa.gerar_historico,
                    exibir_filtro_exames: programa.exibir_filtro_exames,
                }))
            };
    
            if(this.state.doencas_list.length > 0) {
                payload['doencas_register'] = this.state.doencas_list.map(doenca => ({
                    doenca_id: doenca.doenca_id,
                    doenca__nome: doenca.doenca__nome,
                }))
            }
    
            if(this.state.descricao) {
                payload['descricao'] = this.state.descricao;
            }

            //traducoes vao junto: rotulo, descricao, secao e opcoes (o backend confere os valores das opcoes)
            payload['traducoes'] = this.state.traducoes || {};
            const mascaraPayload = this.normalizeMascara(this.state.mascara || '');
            if(mascaraPayload) {
                payload['mascara'] = mascaraPayload;
            }
    
            if(this.state.ordem) {
                payload['ordem'] = this.state.ordem;
            }
            if(this.state.opcoes) {
                payload['opcoes'] = this.state.opcoes;
              }
            if(this.state.obrigatorio) {
                payload['obrigatorio'] = this.state.obrigatorio;
              }
            if(this.state.extencoes_permitidas) {
                payload['extencoes_permitidas'] = this.state.extencoes_permitidas;
              }
            if (this.state.tipo === 'repeater') {
                payload['repetidor'] = this.state.repetidor_list.map((subcampo) => ({
                    nome: subcampo.nome,
                    slug: subcampo.slug,
                    tipo: subcampo.tipo,
                    obrigatorio: subcampo.obrigatorio || false,
                    opcoes: subcampo.opcoes ? sub.opcoes : "",
                    descricao: subcampo.descricao ? sub.descricao : ""
                }));
            }
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.campo_personalizado_atendimento_id) ? 'Campo personalizado atualizado com sucesso' : 'Campo personalizado cadastrado com sucesso';

            if (tipo_update != "ordem") {
                MySwal.fire({
                    title: 'Sucesso!',
                    html: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })
            }

            this.setState({
                loading: false,
                showModalCampo: false
            })
            
            this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb);
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar campo personalizado paciente, verifique os campos e tente novamente';
        
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } 
            else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
        
                if (typeof campos === 'object' && campos !== null) {
                    erro_msg = Object.entries(campos)
                        .map(([campo, mensagens]) => mensagens.join('<br/>'))
                        .join('<br/>');
                } else {
                    erro_msg = String(campos);
                }
            }
        
            if (tipo_update !== "ordem") {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Erro!',
                    html: erro_msg,
                });
            }
        
            this.setState({
                loading: false,
            });
        });        

    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        if (sourceIndex === destinationIndex) {
            return;
        }

        const novasOrdens = Array.from(this.state.listRegistros.results);
        const [removed] = novasOrdens.splice(sourceIndex, 1);
        novasOrdens.splice(destinationIndex, 0, removed);

        novasOrdens.forEach((item, index) => {
            item.ordem = index + 1;
        });

        // Extrai o ID do item arrastado (formato "campo-{id}")
        const draggedId = result.draggableId.split('-')[1];

        this.setState({ 
            campo_personalizado_atendimento_id: draggedId,
            listRegistros: { ...this.state.listRegistros, results: novasOrdens } 
        }, () => {
            this.salvarCampo(null, "ordem");
        });
    };

    moverOrdem = (index, direcao, campo_personalizado_atendimento_id) => {
        this.setState({
            campo_personalizado_atendimento_id: campo_personalizado_atendimento_id
        });

        let novasOrdens = [...this.state.listRegistros.results];

        let campoMovido = { ...novasOrdens[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novasOrdens[index] = novasOrdens[index - 1];
            novasOrdens[index - 1] = campoMovido;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novasOrdens[index].ordem = index + 1;
            novasOrdens[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novasOrdens.length - 1) {
            // Troca a etapa atual com a seguinte
            novasOrdens[index] = novasOrdens[index + 1];
            novasOrdens[index + 1] = campoMovido;
            // Atualiza a ordem
            novasOrdens[index].ordem = index + 1;
            novasOrdens[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ listRegistros: { ...this.state.listRegistros, results: novasOrdens } }, () => {
            //Salva a ordem dos campos
            this.salvarCampo(null,"ordem");
        });
    };

    renderRows = () => {
        const { listRegistros, filtro_programa_id } = this.state;

        // 1) achata cada item em N pares { item, programa }
        let rows = [];
        if (listRegistros?.results?.length) {
            rows = listRegistros.results.flatMap(item =>
            item.programas_list
                // quando há filtro, só inclui o programa filtrado
                .filter(p => !filtro_programa_id || p.programa_id === filtro_programa_id)
                .map(p => ({ item, programa: p }))
            );
        }

        // 2) se tiver pelo menos uma linha, renderiza
        if (rows.length) {
            return rows.map(({ item, programa }, index) => (
            <Draggable 
                key={`${item.id}`} 
                draggableId={`campo-${item.id}`} 
                index={index}
                isDragDisabled={!this.state.filtro_programa_id}
            >
                {(provided, snapshot) => {
                    const style = {
                        ...provided.draggableProps.style,
                        backgroundColor: snapshot.isDragging ? '#e9ecef' : 'white',
                        display: snapshot.isDragging ? 'table' : undefined, 
                        width: snapshot.isDragging ? '100%' : undefined,
                        boxShadow: snapshot.isDragging ? '0 5px 10px rgba(0,0,0,0.15)' : 'none',
                        border: snapshot.isDragging ? '1px solid #dee2e6' : 'none',
                        zIndex: snapshot.isDragging ? 9999 : 'auto',
                    };

                    return (
                        <tr 
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={style}
                            key={`${item.id}-${programa.programa_id}-${index}`}
                        >
                            <td>
                                {this.state.filtro_programa_id && (
                                    <span 
                                        {...provided.dragHandleProps} 
                                        style={{ cursor: 'grab', marginRight: '10px', color: '#6c757d', fontSize: '1.1em' }}
                                        title="Clique e arraste para reordenar"
                                    >
                                        <FaGripVertical />
                                    </span>
                                )}
                                {item.id}
                            </td>
                            <td>{item.nome}</td>

                            {/* Coluna Programa */}
                            <td>{programa.programa__nome}</td>

                            {/* Coluna Seção (só aparece se houver filtro) */}
                            {filtro_programa_id && (
                            <td>{programa.secao || '-'}</td>
                            )}

                            <td>{item.slug}</td>
                            <td>{item.tipo}</td>

                            {/* Coluna Ordem */}
                            <td>
                            <div className="d-flex align-items-center gap-2">
                                <span style={{ minWidth: '20px', fontWeight: 'bold' }}>
                                    {programa.ordem ?? '-'}
                                </span>

                                {filtro_programa_id &&  (
                                    <div className="d-flex flex-column text-muted opacity-50">
                                        {index > 0 && (
                                            <FaArrowUp style={{ fontSize: '0.7rem' }} />
                                        )}
                                        {index < rows.length - 1 && (
                                            <FaArrowDown style={{ fontSize: '0.7rem' }} />
                                        )}
                                    </div>
                                )}
                            </div>
                            </td>

                            <td className="text-end">
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        variant="outline-secondary" 
                                        size="sm"
                                        title="Editar"
                                        onClick={() => this.handleOpenModalCampo(item, programa.programa_id)}
                                    >
                                        <FaRegEdit />
                                    </Button>
                                    <Button
                                        variant="outline-danger" 
                                        size="sm"
                                        title="Excluir" 
                                        onClick={() => this.handleDelete(item.id, programa.programa_id)}
                                    >
                                        <FaTrash />
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    );
                }}
            </Draggable>
            ));
        }

        // 3) se não tiver nenhuma linha
        return (
            <tr>
            <td colSpan={filtro_programa_id ? 8 : 7}>
                {filtro_programa_id
                ? 'Nenhum campo encontrado para o programa selecionado'
                : 'Nenhum campo personalizado de atendimento encontrado'}
            </td>
            </tr>
        );
    };

    

    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/atendimentos/campos/${id}`)
                .then(response => {
                    Swal.fire(
                        'Excluído!',
                        'O campo personalizado atendimento foi excluído com sucesso.',
                        'success'
                    );
                    this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb);
                })
                .catch(error => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir o campo personalizado atendimento.',
                        'error'
                    );
                });
            }
        });
    }

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaCamposPersonalizados(this.state.busca, num_page)
    }

    buscaRegistro(e) {
        e.preventDefault();
        // Verifica se o programa foi selecionado
        if (!this.state.filtro_programa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: '<p>Por favor, selecione um programa para continuar.</p>',
                showCloseButton: true,
            });
            return;
        }

        this.setState({
            loading: true,
        });
        
        this.consultaCamposPersonalizados(this.state.busca)
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState({
                listRegistros: {},
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label
            }, () => {
                this.consultaCamposPersonalizados(this.state.busca, 1);
            });
        }
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_programa_id: null
        }, () => {
            this.consultaCamposPersonalizados(this.state.busca, 1);
        })  
    }

    async carregarCampoPersonalizadoAtendimento(id) {
        try {
            const response = await api.get(`/atendimentos/campos/${id}/`);
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar campo completo:', error);
            return null;
        }
    }

    handleOpenModalCampo = async (item) => {
        this.setState({
            campo_personalizado_atendimento_id: '',
            nome: '',
            slug: '',
            descricao: '',
            ordem: '',
            tipo: '',
            obrigatorio: '',
            extencoes_permitidas: '',
            opcoes: '',
            mascara: '',
            programas_list: [],
            doencas_list: [],
            repetidor_list: [],
            traducoes: {},
            mostrarTraducoes: false
        }, () => {
            if(item.id) {
                this.setState({
                    showModalCampo: true,
                    campo_personalizado_atendimento_id: item.id,
                    nome: item.nome,
                    slug: item.slug,
                    descricao: item.descricao,
                    ordem: item.ordem,
                    tipo: item.tipo,
                    obrigatorio: item.obrigatorio,
                    extencoes_permitidas: item.extencoes_permitidas,
                    opcoes: item.opcoes,
                    mascara: item.mascara,
                    programas_list: item.programas_list || [],
                    doencas_list: item.doencas_list || [],
                    repetidor_list: item.repetidor_list,
                    traducoes: item.traducoes || {}
                });
            } else {
                this.setState({
                    showModalCampo: true
                });
            }
        });
    }

    handleCloseModalCampo = () => {
        this.setState({
            showModalCampo: false
        });
    }

    carregarProgramas = async (inputValue, index, tipo = 'principal') => {
        if(tipo != 'principal') {
            if(!this.state.programas_list[index].focusPrograma) {
                return [];
            }
        } else {
            if(!this.state.focusPrograma) {
                return [];
            }
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    adicionarPrograma() {
        this.setState(prevState => ({
            programas_list: [...prevState.programas_list, { programa_id: null, programa__nome: '', secao: '', disclaimer: '', gerar_historico: false, exibir_filtro_exames: false }],
        }));
    }

    removerPrograma(index) {
        this.setState(prevState => ({
            programas_list: prevState.programas_list.filter((_, i) => i !== index),
        }));
    }

    carregarDoencas = async (inputValue, index) => {
        if(!this.state.doencas_list[index].focusDoencaRelacionada) {
            return [];
        }

        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };

    adicionarDoenca() {
        this.setState(prevState => ({
            doencas_list: [...prevState.doencas_list, { doenca_id: null, doenca__nome: ''}],
        }));
    }

    removerDoenca(index) {
        this.setState(prevState => ({
            doencas_list: prevState.doencas_list.filter((_, i) => i !== index),
        }));
    }

    handleChange = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            const newState = { [name]: value };
    
            //SLUG automatico
            if (name === 'nome') {
                newState.slug = this.gerarSlug(value);
            }
    
            this.setState(newState);
        }
    };

    handleChangePrograma(index, selectedOption) {
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index] = {
                ...programas_list[index],
                programa_id: selectedOption.value,
                programa__nome: selectedOption.label,
            };
            return { programas_list };
        });
    }

    handleSecaoChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].secao = value;
            return { programas_list };
        });
    }

    handleDisclaimerChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].disclaimer = value;
            return { programas_list };
        });
    }

    toggleGerarHistorico = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            gerar_historico: !programas[index].gerar_historico,
        };
        this.setState({ programas_list: programas });
    };

    toggleExibirFiltroExames = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            exibir_filtro_exames: !programas[index].exibir_filtro_exames,
        };
        this.setState({ programas_list: programas });
    };
    handleChangeDoenca(index, selectedOption) {
        this.setState(prevState => {
            const doencas_list = [...prevState.doencas_list];
            doencas_list[index] = {
                ...doencas_list[index],
                doenca_id: selectedOption.value,
                doenca__nome: selectedOption.label,
            };
            return { doencas_list };
        });
    }

    adicionarRepetidor = () => {
        this.setState(prev => ({
            repetidor_list: [
                ...prev.repetidor_list,
                {
                    nome: '',
                    slug: '',
                    tipo: '',
                    opcoes: '',
                    descricao: '',
                    obrigatorio: false
                }
            ]
        }));
    };

    removerRepetidor = async (index) => {
        const MySwal = withReactContent(Swal);

        const resultado = await MySwal.fire({
            title: 'Tem certeza que deseja remover este campo?',
            text: 'Qualquer informação vinculada a ele será perdida.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, remover',
            cancelButtonText: 'Cancelar',
            showCloseButton: true,
        });

        if (resultado.isConfirmed) {
            const list = [...this.state.repetidor_list];
            list.splice(index, 1);
            this.setState({ repetidor_list: list });
        }
    };

    handleChangeRepetidor = (index, campo, valor) => {
        const list = [...this.state.repetidor_list];
        list[index][campo] = valor;
        this.setState({ repetidor_list: list });
    };
    
    gerarSlug = (nome) => {
        return nome
            .toLowerCase()
            .normalize('NFD') // Remove acentos
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9-]/g, '-') // Substitui caracteres inválidos
            .replace(/--+/g, '-')        // Remove hífens duplicados
            .replace(/^-|-$| /g, '');    // Remove hífen do início/fim e espaços
    };

    render() {
        if (!hasPerm('view_campos_personalizados_atendimentos')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Campos Personalizados Atendimentos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" onClick={this.handleOpenModalCampo} className="mb-3" size="sm">
                            <FaPlus /> Adicionar Campo Personalizado Atendimento
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaRegistro}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            key={this.state.focusPrograma}
                                            loadOptions={(inputValue) => {
                                                return new Promise((resolve) => {
                                                    clearTimeout(this.programaSearchTimeout);
                                                    this.programaSearchTimeout = setTimeout(() => {
                                                        resolve(this.carregarProgramas(inputValue));
                                                    }, 700);
                                                });
                                            }}
                                            onFocus={() => {
                                                this.setState({
                                                    focusPrograma: true
                                                });
                                            }}
                                            autoFocus={this.state.focusPrograma}
                                            openMenuOnFocus={this.state.focusPrograma}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder="Nome do Programa"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                {this.state.filtro_programa_id &&
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome</Form.Label>                                  
                                            <Form.Control
                                                type="text"
                                                name="busca"
                                                value={this.state.busca}
                                                onChange={this.onChangeBusca}
                                                placeholder="Nome do Campo Personalizado"
                                                aria-label="Nome do Campo Personalizado"
                                                aria-describedby="basic-addon2"
                                            />
                                        </Form.Group>
                                    </Col>
                                }
                            </Row>
                            <Button type="submit" variant="secondary" size="sm">
                                <FaSearch /> Filtrar
                            </Button>
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Programa</th>
                                    {this.state.filtro_programa_id && (
                                        <th>Seção</th> 
                                    )}
                                    <th>Slug</th>
                                    <th>Tipo</th>
                                    <th>Ordem</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <StrictModeDroppable droppableId="lista-campos-atendimentos" isDropDisabled={!this.state.filtro_programa_id}>
                                {(provided) => (
                                    <tbody
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                    >
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={6}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={6}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                                    {provided.placeholder}
                                    </tbody>
                                )}
                            </StrictModeDroppable>
                        </Table>
                    </DragDropContext>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} limit={this.state.limit_results} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>


                <Modal show={this.state.showModalCampo} onHide={this.handleCloseModalCampo} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>{((this.state.campo_personalizado_atendimento_id) ? 'Editar Campo Personalizado Atendimento ' + this.state.campo_personalizado_atendimento_id : 'Adicionar Campo Personalizado Atendimento')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Campos Personalizado Atendimento</h4>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome <span style={{ color: 'red' }}> *</span></Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={this.state.nome} 
                                                                onChange={e => this.handleChange(e, 'nome')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo do Campo</Form.Label>
                                                            <Form.Control as="select" name="tipo" value={this.state.tipo} required onChange={e => this.handleChange(e, 'tipo')}>
                                                                <option value="">Tipo</option>
                                                                {Object.entries(tiposCampos).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Slug <span style={{ color: 'red' }}> *</span></Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="slug"
                                                                value={this.state.slug}
                                                                onChange={(e) => this.handleChange(e, 'slug')}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Máscara para Campo</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="mascara" 
                                                                value={this.state.mascara} 
                                                                onChange={e => this.handleChange(e, 'mascara')} 
                                                            />
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Possível fornecer máscara para o campo, exemplo: 99999-999
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Campo Obrigatório?</Form.Label>
                                                            <Form.Select className="form-control" name="obrigatorio" value={this.state.obrigatorio.toString()} onChange={e => this.handleChange(e, 'obrigatorio')}>
                                                                <option value="false">Não</option>
                                                                <option value="true">Sim</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {(this.state.tipo == 'arquivo') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Extensões Permitidas</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="extencoes_permitidas" 
                                                                value={this.state.extencoes_permitidas} 
                                                                onChange={e => this.handleChange(e, 'extensoes_permitidas')} 
                                                            />
                                                        </Form.Group>
                                                        <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                            Informe as extensões permitidas para o campo separadas por vírgula, por exemplo: .jpg, .png, .pdf
                                                        </Form.Text>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(this.state.tipo == 'selecao' || this.state.tipo == 'checkbox' || this.state.tipo == 'radio') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valores do Campo</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="opcoes" 
                                                                value={this.state.opcoes} 
                                                                onChange={e => this.handleChange(e, 'opcoes')} 
                                                            />
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Informe as opções disponíveis para escolha do campo no formato chave:valor com um item por linha. Por exemplo, para um campo para escolha de cor as opções poderiam ser:<br />
                                                                vermelho:Vermelho<br />
                                                                azul:Azul<br />
                                                                verde:Verde
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                )}
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="descricao" 
                                                                value={this.state.descricao} 
                                                                onChange={e => this.handleChange(e, 'descricao')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {this.state.tipo === 'repeater' && (
                                                    <>
                                                        <Card>
                                                            <CardBody>
                                                                <h5 className="mt-4 mb-2">Subcampos (Repetidor)</h5>
                                                                {this.state.repetidor_list.map((subcampo, index) => (
                                                                    <div key={index} className="border rounded p-3 mb-3">
                                                                        <Row>
                                                                            <Col sm={6}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Nome</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={subcampo.nome}
                                                                                        onChange={(e) => this.handleChangeRepetidor(index, 'nome', e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={6}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Tipo do Campo</Form.Label>
                                                                                    <Form.Control
                                                                                        as="select"
                                                                                        value={subcampo.tipo}
                                                                                        onChange={(e) => this.handleChangeRepetidor(index, 'tipo', e.target.value)}
                                                                                    >
                                                                                        <option value="">Tipo</option>
                                                                                        {Object.entries(tiposRepeater).map(([sigla, nome]) => (
                                                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                                                        ))}
                                                                                    </Form.Control>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Slug</Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        value={subcampo.slug}
                                                                                        onChange={(e) => this.handleChangeRepetidor(index, 'slug', e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={4}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Campo Obrigatório?</Form.Label>
                                                                                    <Form.Select className="form-control" value={subcampo.obrigatorio?.toString() || 'false'} onChange={(e) => this.handleChangeRepetidor(index, 'obrigatorio', e.target.value === 'true')}>
                                                                                        <option value="false">Não</option>
                                                                                        <option value="true">Sim</option>
                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                        {(subcampo.tipo === 'selecao' || subcampo.tipo === 'checkbox' || subcampo.tipo === 'radio') && (
                                                                            <Row>
                                                                                <Col>
                                                                                    <Form.Group className="mb-3">
                                                                                        <Form.Label>Valores do Campo</Form.Label>
                                                                                        <Form.Control
                                                                                            as="textarea"
                                                                                            rows={2}
                                                                                            value={subcampo.opcoes || ''}
                                                                                            onChange={(e) => this.handleChangeRepetidor(index, 'opcoes', e.target.value)}
                                                                                        />
                                                                                        <Form.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                                                                                            Informe as opções disponíveis no formato chave:valor, uma por linha.
                                                                                        </Form.Text>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                        )}

                                                                        <Row>
                                                                            <Col>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Descrição</Form.Label>
                                                                                    <Form.Control
                                                                                        as="textarea"
                                                                                        value={subcampo.descricao || ''}
                                                                                        onChange={(e) => this.handleChangeRepetidor(index, 'descricao', e.target.value)}
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>

                                                                        <Row>
                                                                            <Col className="text-end">
                                                                                <Button variant="danger" size="sm" onClick={() => this.removerRepetidor(index)}>Remover Subcampo</Button>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))}

                                                                <Button variant="outline-success" size="sm" onClick={this.adicionarRepetidor}>
                                                                    Adicionar Subcampo
                                                                </Button>
                                                            </CardBody>
                                                        </Card> 
                                                    </>
                                                )}

                                                <br></br>
                                                <Card>
                                                    <CardBody>
                                                        <h4 className="mt-3">Programas</h4>
                                                        {this.state.programas_list.map((programa, index) => (
                                                            <div key={index}>
                                                                <Row>
                                                                    <Col sm={4} xs={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Programa</Form.Label>
                                                                            <AsyncSelect
                                                                                key={this.state.programas_list[index].focusPrograma}
                                                                                loadOptions={(inputValue) => {
                                                                                    return new Promise((resolve) => {
                                                                                        clearTimeout(this.state.programas_list[index].programaSearchTimeout);
                                                                                        programa.programaSearchTimeout = setTimeout(() => {
                                                                                            resolve(this.carregarProgramas(inputValue, index, 'programas'));
                                                                                        }, 700);
                                                                                    });
                                                                                }}
                                                                                onFocus={() => {
                                                                                    this.setState({
                                                                                        programas_list: this.state.programas_list.map((programa, i) => i === index ? { ...programa, focusPrograma: true } : programa)
                                                                                    });
                                                                                }}
                                                                                autoFocus={this.state.programas_list[index].focusPrograma}
                                                                                openMenuOnFocus={this.state.programas_list[index].focusPrograma}
                                                                                defaultOptions
                                                                                name="programa_id"
                                                                                placeholder="Buscar programa..."
                                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                                onChange={e => this.handleChangePrograma(index, e)}
                                                                                value={programa.programa_id ? { value: programa.programa_id, label: programa.programa__nome } : null}
                                                                            />
                                                                            <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    {programa.programa_id && (
                                                                        <>
                                                                            <Col sm={4} xs={12}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Seção</Form.Label>
                                                                                    <Form.Control 
                                                                                        type="text" 
                                                                                        name="secao" 
                                                                                        value={programa.secao} 
                                                                                        onChange={e => this.handleSecaoChange(index, e)} 
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                            <Col sm={4} xs={12}>
                                                                                <Form.Group className="mb-3">
                                                                                    <Form.Label>Disclaimer</Form.Label>
                                                                                    <Form.Control 
                                                                                        type="text" 
                                                                                        name="disclaimer" 
                                                                                        value={programa.disclaimer} 
                                                                                        onChange={e => this.handleDisclaimerChange(index, e)} 
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </>
                                                                    )}
                                                                    {programa.programa_id && (
                                                                        <Col >
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Check 
                                                                                    type="checkbox" 
                                                                                    label="Gerar Histórico" 
                                                                                    checked={programa.gerar_historico || false}
                                                                                    onChange={() => this.toggleGerarHistorico(index)}
                                                                                />
                                                                            </Form.Group>
                                                                            <Form.Group className="mb-3">
                                                                                <Form.Check 
                                                                                    type="checkbox" 
                                                                                    label="Exibir no filtro de Exames?" 
                                                                                    checked={programa.exibir_filtro_exames || false}
                                                                                    onChange={() => this.toggleExibirFiltroExames(index)}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    )}
                                                                </Row>
                                                            </div>
                                                        ))}
                                                        <Row>
                                                            <Col sm={12} xs={12}>
                                                                <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarPrograma(0)}>Adicionar Programa</Button>
                                                                <Button variant="danger" className="btn-sm" onClick={() => this.removerPrograma(0)}> Remover Programa</Button>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                                <br></br>
                                                <Card>
                                                    <CardBody> 
                                                        <h4 className="mt-3">Doenças</h4>
                                                        {this.state.doencas_list.map((doenca, index) => (
                                                            <div key={index}>
                                                                <Row>
                                                                    <Col sm={4} xs={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Doença</Form.Label>
                                                                            <AsyncSelect
                                                                                key={this.state.doencas_list[index].focusDoencaRelacionada}
                                                                                loadOptions={(inputValue) => {
                                                                                    return new Promise((resolve) => {
                                                                                        clearTimeout(this.state.doencas_list[index].doencaRelacionadaSearchTimeout);
                                                                                        doenca.doencaRelacionadaSearchTimeout = setTimeout(() => {
                                                                                            resolve(this.carregarDoencas(inputValue, index));
                                                                                        }, 700);
                                                                                    });
                                                                                }}
                                                                                onFocus={() => {
                                                                                    this.setState({
                                                                                        doencas_list: this.state.doencas_list.map((doenca, i) => i === index ? { ...doenca, focusDoencaRelacionada: true } : doenca)
                                                                                    });
                                                                                }}
                                                                                autoFocus={this.state.doencas_list[index].focusDoencaRelacionada}
                                                                                openMenuOnFocus={this.state.doencas_list[index].focusDoencaRelacionada}
                                                                                defaultOptions
                                                                                name="doença_id"
                                                                                placeholder="Buscar doença..."
                                                                                noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                                onChange={e => this.handleChangeDoenca(index, e)}
                                                                                value={doenca.doenca_id ? { value: doenca.doenca_id, label: doenca.doenca__nome } : null}
                                                                            />
                                                                            <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                        </Form.Group>
                                                                    </Col>

                                                                </Row>
                                                            </div>
                                                        ))}
                                                        <Row>
                                                            <Col sm={12} xs={12}>
                                                                <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarDoenca(0)}>Adicionar Doença</Button>
                                                                <Button variant="danger" className="btn-sm" onClick={() => this.removerDoenca(0)}> Remover Doença</Button>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                    </Form> 

                                    {/* traducoes no proprio modal: um segundo modal por cima disputaria o foco com este */}
                                    <div className="mt-4">
                                        <Button variant="link" className="p-0" onClick={() => this.setState({ mostrarTraducoes: !this.state.mostrarTraducoes })}>
                                            {this.state.mostrarTraducoes ? '▾' : '▸'} Traduções (inglês e espanhol)
                                        </Button>
                                        {this.state.mostrarTraducoes && (
                                            <div className="mt-3">
                                                <CamposTraducao
                                                    campos={[
                                                        { campo: 'nome', rotulo: 'Nome', original: this.state.nome },
                                                        { campo: 'descricao', rotulo: 'Descrição', original: this.state.descricao, multilinha: true },
                                                        { campo: 'secao', rotulo: 'Seção', original: [...new Set((this.state.programas_list || []).map(p => p.secao).filter(Boolean))].join(' / ') },
                                                        ...(['radio', 'selecao', 'checkbox'].includes(this.state.tipo) ? [{
                                                            campo: 'opcoes', rotulo: 'Opções', original: this.state.opcoes, multilinha: true,
                                                            ajuda: 'Uma opção por linha, no formato valor:Texto. Mantenha o valor (antes dos dois-pontos) igual ao original; traduza só o texto.',
                                                        }] : []),
                                                    ]}
                                                    traducoes={this.state.traducoes}
                                                    onChange={(idioma, campo, valor) => this.setState({ traducoes: alteraTraducao(this.state.traducoes, idioma, campo, valor) })}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </Card.Body>                
                            </Card>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalCampo}>
                            Fechar
                        </Button>
                        <Button variant="secondary" onClick={(e) => this.salvarCampo(e)}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.campo_personalizado_atendimento_id) ? 'Editar Campo Personalizado Atendimento ' + this.state.campo_personalizado_atendimento_id : 'Cadastrar Campo Personalizado Atendimento'}      
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(CamposPersonalizadosAtendimentos);
